import React from 'react';
import { format, parseISO } from 'date-fns';

import { FlightStopsContainer } from './FlightStops.style';
//import Style from '../style.module.css';
import '../style.css';
import DotArrive from '@images/dot_arrive.svg';

import { translate as t } from '@utils/translate';

const FlightStops = ({
  departureDatetime,
  originSpot,
  destinationSpot,
  estimatedArrivalDatetime,
}) => {
  const TEXTS = {
    EXIT: t('departure'),
    ARRIVAL: t('arrival'),
  };

  return (
    <>
      <FlightStopsContainer className="stopItem">
        <div>
          <span className="dotDeparture"></span>
          <i className="dotPath" />
          <i className="dotPath" />
          <i className="dotPath" />
          <i className="dotPath" />
          <i className="dotPath" />
          <i className="dotPath" />
        </div>
        <div className="stopMeta">
          <p className="time">
            <span>{TEXTS.EXIT}</span>{' '}
            {format(parseISO(departureDatetime), 'HH:mm')}
          </p>
          <p className="codes">
            {!originSpot.airport && !originSpot.helipad ? (
              <span>ZZZZ</span>
            ) : (
              <>
                <span>
                  {originSpot.airport
                    ? originSpot.airport.acronym
                      ? originSpot.airport.acronym
                      : originSpot.airport.oaci
                    : originSpot.helipad.oaci}
                </span>
                {originSpot.airport !== undefined
                  ? `, ${originSpot.airport.oaci || originSpot.helipad.oaci}`
                  : null}
              </>
            )}
          </p>
          <p className="airport">
            {originSpot.name} · <span>{originSpot.address.city.name}</span>
          </p>
        </div>
      </FlightStopsContainer>
      <FlightStopsContainer className="stopItem">
        <img src={DotArrive} alt="" className="dotArrive" />
        <div className="stopMeta">
          <p className="time">
            <span>{TEXTS.ARRIVAL}</span>{' '}
            {format(parseISO(estimatedArrivalDatetime), 'HH:mm')}
          </p>
          <p className="codes">
            {!destinationSpot.airport && !destinationSpot.helipad ? (
              <span>ZZZZ</span>
            ) : (
              <>
                <span>
                  {destinationSpot.airport
                    ? destinationSpot.airport.acronym ||
                      destinationSpot.airport.oaci
                    : destinationSpot.helipad.oaci}
                </span>
                {destinationSpot.airport !== undefined
                  ? `, ${destinationSpot.airport.oaci ||
                      destinationSpot.helipad.oaci}`
                  : null}
              </>
            )}
          </p>
          <p className="airport">
            {destinationSpot.name} ·{' '}
            <span>{destinationSpot.address.city.name}</span>
          </p>
        </div>
      </FlightStopsContainer>
    </>
  );
};

export default FlightStops;
